module.exports = __webpack_public_path__ + "img/login.6300d2f4.png";